import Sizeable from "../../mixins/Sizeable";
import Colorable from "../../mixins/Colorable";

export default {
    mixins: [Sizeable, Colorable],

    props: {

        // The size of the icon to show
        size: {
            type: [String, Number],
            default: 24
        },

        spinning: {
            type: Boolean,
            default: false
        }
    },
}
